import http from "@/api/config/http-configs";

export const uploadFileWithServe = (file, path) => {
    const url = '/manage/file/upload'
    const formData = new FormData();
    console.log("@@@ uploadFileWithServe", file, path)

    formData.append('file', file);
    formData.append('path', path);

    const config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }

    return http.post(url, formData, config)
}


